export default __webpack_public_path__ + "static/media/alive-game-hd-photo.77f5a831.jpg";